import styled from 'styled-components';

export const Bold = styled.span`
  font-weight: 700;
`;

export const getContinueButtonText = ({ dynamicWidth }) => {
  if (dynamicWidth < 530) {
    return 'Activities.ContinueShort';
  }

  if (dynamicWidth < 1300) {
    return 'Activities.Continue';
  }

  return 'Activities.ContinueFull';
};

const styles = {
  cardContainer: {
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
  },
};

export const getCardContainerStyles = ({ isTabletLG }) => ({
  ...styles.cardContainer,
  minHeight: isTabletLG ? 378 : 478,
});
